let html = `<div class="account-modal-split">
    <div class="account-modal-split__qr">
        <img class="account-modal-split__qr-img hide" />
        <div class="account-modal-split__qr-code"></div>
        <div class="account-modal-split__qr-text">{qr_text}</div>
    </div>

    <div class="account-modal-split__info">
        <div class="account-modal-split__title">{title}</div>
        <div class="account-modal-split__text">{text}</div>
    </div>
</div>`

export default html